// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as BulkUploadRepoConfig from "./BulkUploadRepoConfig.bs.js";

var dummyBulkUploadResponse = {
        "error_type":"DRIVER_REQUEST_FAILURE",
        "errors":[
          {
            "driver_request": {
              "driver_msisdn":"0000000000000",
              "vehicle_number":"KA-00-00-0000",
              "amount":44.0,
              "partner_comment":"Released Agains",
              "admin_comment":"Test Comments"
            },
            "failure_reason":"City Mismatch"
          },
          {
            "driver_request": {
              "driver_msisdn":"0000000000000",
              "vehicle_number":"MH-00-00-0000",
              "amount":43.0,
              "partner_comment":"Released Again",
              "admin_comment":"Test Comment"
            },
            "failure_reason":"Driver Does not exist"
          }
        ],
        "status":"422"
      };

var dummyBulkReason = {
      "reason": {
        "credit": [
          {
            "id": 1,
            "reason": "Reason A",
            "reason_enum": "Reason_A",
            "is_bulk_txn_allowed": true
          },
          {
            "id": 2,
            "reason": "Reason B",
            "reason_enum": "Reason_B",
            "is_bulk_txn_allowed": true
          },
        ],
        "debit": [
          {
            "id": 3,
            "reason": "Reason C",
            "reason_enum": "Reason_C",
            "is_bulk_txn_allowed": false
          },
          {
            "id": 4,
            "reason": "Reason D",
            "reason_enum": "Reason_D",
            "is_bulk_txn_allowed": true
          }
        ]
      }
    };

function bulkUpload(_request, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyBulkUploadResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BulkUploadRepoConfig.BulkUploadWalletTransactionsResponseConverter.execute, result);
                        });
            });
}

function fetchBulkReasons(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyBulkReason
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BulkUploadRepoConfig.BulkReasonResponseConverter.execute, result);
                        });
            });
}

var BulkUploadRepo = {
  dummyBulkUploadResponse: dummyBulkUploadResponse,
  dummyBulkReason: dummyBulkReason,
  bulkUpload: bulkUpload,
  fetchBulkReasons: fetchBulkReasons
};

export {
  BulkUploadRepo ,
  
}
/* BulkUploadRepoConfig Not a pure module */
